import { Model, } from './Model';
import { Utilities, } from '../utils/Utilities';

export class ModelFactory<T extends Model> {

	constructor(private _modelType: new (...args: any) => T) {
	}

	createNew(json: any): T {
		const model: T = new this.modelType(json);
		model.originalJson = json;
		return model;
	}

	clone(record: T): T {
		return Utilities.deepCloneObject(record);
	}

	newCopy(record: T): T {
		const copy: T = Utilities.deepCloneObject(record);
		copy.id = null;
		copy.originalJson = record.originalJson;
		return copy;
	}

	massage(records: T[]): T[] {
		return records;
	}

	get modelType(): any {
		return this._modelType;
	}
}
